var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 28H20M12 28V21.3333M12 28H4.8C4.58783 28 4.38434 27.9157 4.23431 27.7657C4.08429 27.6157 4 27.4122 4 27.2V22.1333C4 21.9212 4.08429 21.7177 4.23431 21.5676C4.38434 21.4176 4.58783 21.3333 4.8 21.3333H12M20 28V12M20 28H27.2C27.4122 28 27.6157 27.9157 27.7657 27.7657C27.9157 27.6157 28 27.4122 28 27.2V4.8C28 4.58783 27.9157 4.38434 27.7657 4.23431C27.6157 4.08429 27.4122 4 27.2 4H20.8C20.5878 4 20.3843 4.08429 20.2343 4.23431C20.0843 4.38434 20 4.58783 20 4.8V12M12 21.3333V12.8C12 12.5878 12.0843 12.3843 12.2343 12.2343C12.3843 12.0843 12.5878 12 12.8 12H20",
    stroke: "#4B5563",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.10a71abd8a6db630d512ea30ff8a7add.svg";
export { ForwardRef as ReactComponent };